export const formatCnpj = val => {
  if (!val) return '';

  val = val.replace(/\D/g, '');

  if (val.length <= 2) return val.replace(/^(\d+)/, '$1');
  else if (val.length <= 5) return val.replace(/^(\d{2})(\d+)/, '$1.$2');
  else if (val.length <= 8)
    return val.replace(/^(\d{2})(\d{3})(\d+)/, '$1.$2.$3');
  else if (val.length <= 12)
    return val.replace(/^(\d{2})(\d{3})(\d{3})(\d+)/, '$1.$2.$3/$4');
  else
    return val.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/, '$1.$2.$3/$4-$5');
};

export const parseCnpj = val => {
  if (!val) return '';

  return val.replace(/\D/g, '').slice(0, 14);
};

export const formatCpfAndCnpj = (val) => {
  if (!val) return '';

  val = val.replace(/\D/g, '');

  if (val.length <= 3) return val;
  else if (val.length <= 6) return val.replace(/^(\d{3})(\d+)/, '$1.$2');
  else if (val.length <= 9) return val.replace(/^(\d{3})(\d{3})(\d+)/, '$1.$2.$3');
  else if (val.length <= 11) return val.replace(/^(\d{3})(\d{3})(\d{3})(\d+)/, '$1.$2.$3-$4');
  else if (val.length <= 12) return val.replace(/^(\d{2})(\d{3})(\d{3})(\d+)/, '$1.$2.$3/$4');
  else return val.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/, '$1.$2.$3/$4-$5');
};

export const parseCpfAndCnpj = (val) => {
  if (!val) return '';

  val = val.replace(/\D/g, '');
  return val.length <= 11 ? val.slice(0, 11) : val.slice(0, 14);
};

export const formatDate = val => {
  if (!val) return '';

  val = val.replace(/\D/g, '');

  if (val.length <= 2) return val;

  if (val.length <= 4) return val.replace(/^(\d{2})(\d+)/, '$1/$2');

  return val.slice(0, 8).replace(/^(\d{2})(\d{2})(\d+)/, '$1/$2/$3');
};

export function toISODate(value) {
  if (!value) return null;
  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date.toISOString();
}

export function toYyyyMmDd(value) {
  if (!value) return null;
  const date = new Date(value);
  if (isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDateTime(isoDate) {
  let date;
  try {
    date = new Date(isoDate);
  } catch (error) {
    return '';
  }
  
  date.setHours(date.getHours());

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} às ${hours}h${minutes}`;
}
